<!--
 * @Author: your name
 * @Date: 2020-12-25 16:12:53
 * @LastEditTime: 2020-12-25 17:10:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/mine/modifynickname/index.vue
-->
<template>
  <div>
    <title-bar-back :title="'修改昵称'" @back="back">
      <div class="title_right font14 font_weight400" @click="sure">确定</div>
    </title-bar-back>
    <input-clearn
      :placeholder="'请输入昵称'"
      @inputValue="inputValue"
      :value="value"
    />
  </div>
</template>
<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
const InputClearn = () =>
  import("./components/InputClearn").then(m => m.default || m);
export default {
  name: "ModifyNickname",
  components: {
    TitleBarBack,
    InputClearn
  },
  data() {
    return {
      value: this.$route.query.name || ""
    };
  },
  methods: {
    back() {
      this.$router.back();
    },
    inputValue(value) {
      this.value = value;
      // console.log(value);
    },
    sure() {
      if (this.value.trim()) {
        // 调用保存接口 updateUserInfo
        const params = {
          id: this.$route.query.id,
          username: this.value.trim()
        };
        this.$store
          .dispatch("mine/updateUserInfo", { params })
          .then(() => {
            this.$store
              .dispatch("mine/getUserInfo")
              .then(() => {
                this.$router.back();
              })
              .catch(() => {});
          })
          .catch(() => {});
      } else {
        // console.log("请输入昵称");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.title_right {
  width: 36px;
  color: #bf9264;
  line-height: 40px;
}
.modify {
  background: #fff;
}
</style>
